/** Checks for pictures put into an article: from a file dialog, a paste or a drop. */
const MAX_MB = 10;
/** Why the file can't go into an article, or null when it can. */
export function imageFileProblem(file) {
    if (!file.type.startsWith('image/'))
        return `${file.name} — не картинка`;
    if (file.size > MAX_MB * 1024 * 1024)
        return `${file.name} больше ${MAX_MB} МБ`;
    return null;
}
/** Files of a paste, a drop or a file input, as an array. */
export const filesOf = (list) => list ? Array.from(list) : [];
/** Does a drag carry files (not a piece of text)? */
export const dragHasFiles = (types) => !!types && Array.from(types).includes('Files');
